export default "__VITE_ASSET__BE5HR2Fv__"